import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { logout } from '../../store/slices/authSlice';
import { useLogoutUserMutation } from '../../api/services/authApi';
import { persistor } from '../../store';

interface HeaderProps {
  onSidebarToggle: () => void;
  sidebarOpen: boolean;
  isMobile: boolean;
}

const Header: React.FC<HeaderProps> = ({
  onSidebarToggle,
  sidebarOpen,
  isMobile
}) => {
  const dispatch = useAppDispatch();
  const { user }:any = useAppSelector((state) => state?.auth);
  // console.log(user,'useruser');
  



  const [logoutUser] = useLogoutUserMutation();

  const handleLogout = async () => {
    try {
      await logoutUser().unwrap();
      dispatch(logout());

      await persistor.purge();
    } catch (error) {
      console.error('Logout error:', error);
      dispatch(logout()); // Logout locally even if API call fails
    }
  };

  const getHeaderWidth = () => {
    if (isMobile) return '100%';
    return sidebarOpen ? 'calc(100% - 240px)' : 'calc(100% - 72px)';
  };

  const getHeaderMargin = () => {
    if (isMobile) return 0;
    return sidebarOpen ? '240px' : '72px';
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        width: getHeaderWidth(),
        ml: getHeaderMargin(),
        transition: (theme) => theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.standard,
        }),
      }}
    >
      <Toolbar sx={{ minHeight: { xs: 56, sm: 64 },bgcolor:'white' }}>
        <IconButton
          color="inherit"
          aria-label="toggle sidebar"
          edge="start"
          onClick={onSidebarToggle}
          sx={{ mr: 2, color:'black'}}
        >
          <MenuIcon />
        </IconButton>

        <Typography
          variant="h6"
          component="div"
          sx={{
            flexGrow: 1,
            fontSize: { xs: '1.1rem', sm: '1.25rem' },
            fontWeight: 600,
          }}
        >
          {/* B2B Application */}
        </Typography>

        <Box display="flex" alignItems="center" gap={2}>
          <Typography
            variant="body1"
            sx={{
              display: { xs: 'none', sm: 'block' },
              color:'black'
            }}
          >
            Welcome,<b>{user?.USERNAME}</b> 
          </Typography>
          <Button
            color="inherit"
            onClick={handleLogout}
            variant="outlined"
            size="small"
            sx={{
              borderColor: 'rgba(0, 0, 0, 0.3)',
              '&:hover': {
                borderColor: 'rgba(0, 0, 0, 0.5)',
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
              },
              color:'black'
            }}
          >
            Logout
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;